// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_option from "../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Row$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as Button$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/Button.bs.js";
import * as FormInput$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as FormHelper$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as FormTextInput$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormTextInput.bs.js";
import * as FormDateTimeInputTs$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/date-time/FormDateTimeInputTs.bs.js";

function FetchPartnerPenaltiesFormCmp(Props) {
  var form = Props.form;
  return React.createElement(Row$Catalyst.make, {
              children: null,
              className: "fetch-penalty-form"
            }, React.createElement(Row$Catalyst.make, {
                  children: null
                }, React.createElement("div", {
                      className: "form-input-fields"
                    }, React.createElement("div", {
                          className: "label"
                        }, "Order ID"), React.createElement(FormTextInput$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                  return Curry._2(form.updateCrn, (function (input, value) {
                                                return {
                                                        crn: value,
                                                        msisdn: input.msisdn,
                                                        start_date: input.start_date,
                                                        end_date: input.end_date
                                                      };
                                              }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                }), undefined, undefined, "Enter Order ID", undefined, undefined, undefined, form.crnResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                          textinput_props: {
                            value: form.input.crn
                          }
                        })), React.createElement("div", {
                      className: "form-input-fields"
                    }, React.createElement("div", {
                          className: "label"
                        }, "MSISDN"), React.createElement(FormTextInput$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                  return Curry._2(form.updateMsisdn, (function (input, value) {
                                                return {
                                                        crn: input.crn,
                                                        msisdn: value,
                                                        start_date: input.start_date,
                                                        end_date: input.end_date
                                                      };
                                              }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                }), undefined, undefined, "Enter MSISDN", undefined, undefined, undefined, form.msisdnResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                          textinput_props: {
                            value: form.input.msisdn
                          }
                        })), React.createElement("div", {
                      className: "form-input-fields"
                    }, React.createElement("div", {
                          className: "label"
                        }, "Date Range"), React.createElement(Row$Catalyst.make, {
                          children: null
                        }, React.createElement(FormDateTimeInputTs$Catalyst.make, {
                              input_props: FormInput$Catalyst.make_props("Start Date", (function (param) {
                                      
                                    }), undefined, undefined, undefined, undefined, undefined, undefined, form.start_dateResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                              date_props: {
                                value: form.input.start_date,
                                minDate: undefined,
                                maxDate: form.input.end_date,
                                onChange: (function (date) {
                                    return Curry._2(form.updateStart_date, (function (input, value) {
                                                  return {
                                                          crn: input.crn,
                                                          msisdn: input.msisdn,
                                                          start_date: value,
                                                          end_date: input.end_date
                                                        };
                                                }), Caml_option.some(date));
                                  }),
                                format: "DD/MM/YYYY",
                                isDisabled: false,
                                onClear: (function (param) {
                                    return Curry._2(form.updateStart_date, (function (input, value) {
                                                  return {
                                                          crn: input.crn,
                                                          msisdn: input.msisdn,
                                                          start_date: value,
                                                          end_date: input.end_date
                                                        };
                                                }), undefined);
                                  })
                              }
                            }), React.createElement(FormDateTimeInputTs$Catalyst.make, {
                              input_props: FormInput$Catalyst.make_props("End Date", (function (param) {
                                      
                                    }), undefined, undefined, undefined, undefined, undefined, undefined, form.end_dateResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                              date_props: {
                                value: form.input.end_date,
                                minDate: form.input.start_date,
                                maxDate: undefined,
                                onChange: (function (date) {
                                    return Curry._2(form.updateEnd_date, (function (input, value) {
                                                  return {
                                                          crn: input.crn,
                                                          msisdn: input.msisdn,
                                                          start_date: input.start_date,
                                                          end_date: value
                                                        };
                                                }), Caml_option.some(date));
                                  }),
                                format: "DD/MM/YYYY",
                                isDisabled: false,
                                onClear: (function (param) {
                                    return Curry._2(form.updateEnd_date, (function (input, value) {
                                                  return {
                                                          crn: input.crn,
                                                          msisdn: input.msisdn,
                                                          start_date: input.start_date,
                                                          end_date: value
                                                        };
                                                }), undefined);
                                  })
                              }
                            })))), React.createElement(Button$Catalyst.make, {
                  text: "Get Penalty List",
                  cb: (function (param) {
                      return Curry._1(form.submit, undefined);
                    }),
                  className: "submit-btn"
                }));
}

var make = FetchPartnerPenaltiesFormCmp;

export {
  make ,
  
}
/* react Not a pure module */
